import type { BreakoutDefinition, FocusAreaId } from '../types';
import { GET_OFF_THE_GRID } from './getOffTheGrid';

/** Data-driven Breakout catalog. V1 ships Get Off the Grid fully; others are stubs for later fill. */
export const BREAKOUT_CATALOG: BreakoutDefinition[] = [
  GET_OFF_THE_GRID,
  {
    id: 'breakout_talk_to_him',
    slug: 'talk-to-him',
    title: 'Talk to Him',
    durationDays: 14,
    focusAreaIds: ['connect'],
    tagline: 'Practice approaching without disappearing into the phone.',
    safetyClass: 'standard',
    stages: [],
    moves: [],
  },
  {
    id: 'breakout_break_the_loop',
    slug: 'break-the-loop',
    title: 'Break the Loop',
    durationDays: 30,
    focusAreaIds: ['apps', 'sex', 'life'],
    tagline: 'Interrupt the pattern that keeps putting you back where you started.',
    safetyClass: 'standard',
    stages: [],
    moves: [],
  },
];

export const getBreakoutById = (id: string): BreakoutDefinition | undefined =>
  BREAKOUT_CATALOG.find((b) => b.id === id);

export const getBreakoutBySlug = (slug: string): BreakoutDefinition | undefined =>
  BREAKOUT_CATALOG.find((b) => b.slug === slug);

export const breakoutsForFocus = (focusAreaId: FocusAreaId): BreakoutDefinition[] =>
  BREAKOUT_CATALOG.filter((b) => b.focusAreaIds.includes(focusAreaId) && b.moves.length > 0);
